<!-- <app-header></app-header>
<app-home></app-home>
<app-footer></app-footer> -->
<!-- <div *ngIf="showSideBar">
    <app-dashboard-header ></app-dashboard-header>
</div> -->
<!-- <app-spinner></app-spinner> -->

<router-outlet></router-outlet>
<app-cookie-consent></app-cookie-consent>